"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = require("react");

var context_1 = require("./context");

function useServerEffect(perform, kind) {
  var manager = react_1.useContext(context_1.EffectContext);

  if (manager == null || kind != null && !manager.shouldPerform(kind)) {
    return;
  }

  manager.add(perform(), kind);
}

exports.useServerEffect = useServerEffect;